<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M8.632 9.24h2.906a1 1 0 010 2h-4.66a1 1 0 01-1-1V5.583a1 1 0 012 0v1.58a12.002 12.002 0 0116.607 17.321 12.002 12.002 0 01-16.97 0A11.996 11.996 0 014.041 17c-.046-.55.406-.999.959-.999.552 0 .995.45 1.05.999A9.997 9.997 0 0016 26a10.002 10.002 0 0010.002-9.999 9.997 9.997 0 00-6.372-9.317A10.003 10.003 0 008.634 9.24h-.002z"/></svg>
</template>

<script>
export default {
  name: 'arrowsCounterClockwise'
}
</script>
